import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import ClientLogosSection from './components/ClientLogosSection/ClientLogosSection';
import SoftwareSection from './components/SoftwareSection/SoftwareSection';
import KitsSection from './components/KitsSection/KitsSection';
import InstallationSection from './components/InstallationSection/InstallationSection';
import AdvantagesSection from './components/AdvantagesSection/AdvantagesSection';
import MobileAppSection from './components/MobileAppSection/MobileAppSection';
import TestimonialsSection from './components/TestimonialsSection/TestimonialsSection';
import CTASection from './components/CTASection/CTASection';
import Footer from './components/Footer/Footer';
import ConnectSection from './components/ConnectSection/ConnectSection';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import ScrollToTop from './utils/ScrollToTop';
import { HelmetProvider } from 'react-helmet-async';

// Component to render the main page layout
const MainPageLayout = () => (
  <>
    <Hero />
    <ClientLogosSection />
    <SoftwareSection />
    <KitsSection />
    <InstallationSection />
    <AdvantagesSection />
    <MobileAppSection />
    <TestimonialsSection />
    <CTASection />
    <ConnectSection />
  </>
);

function App() {
  // JavaScript logic for scroll animations, navbar active state, etc.,
  // will be handled within respective components or custom hooks.

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<MainPageLayout />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;
